// Animates the calendar grid when navigating between weeks.
// Reads direction from sessionStorage (set by calendar-week-nav on link mousedown)
// and applies a slide-in transition.
import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "calendarNavDirection"
const DURATION_MS = 180

export default class extends Controller {
  static targets = ["content"]

  connect() {
    const direction = sessionStorage.getItem(STORAGE_KEY)
    sessionStorage.removeItem(STORAGE_KEY)

    if (!direction || !this.hasContentTarget) return

    const content = this.contentTarget

    // Initial off-screen position
    if (direction === "next") {
      content.classList.add("translate-x-full")
    } else if (direction === "prev") {
      content.classList.add("-translate-x-full")
    } else {
      return
    }

    // Enable transition and animate to visible
    content.classList.add("transition-transform", "ease-out")
    content.style.transitionDuration = `${DURATION_MS}ms`

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        content.classList.remove("translate-x-full", "-translate-x-full")
      })
    })

    // Remove transition class after animation to avoid affecting layout later
    setTimeout(() => {
      content.classList.remove("transition-transform")
      content.style.transitionDuration = ""
    }, DURATION_MS + 50)
  }
}
